export default function(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-collection/src/entries.js
// module id = ./node_modules/d3-collection/src/entries.js
// module chunks = vendor